<template>
<fragment>
    <InsideHeader :title="pageData.heading" :bredcrumb="breadcrumb" />
    <section class="blog-page-area service-details-page-area-2">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                    <div id="content">
                        <div class="block-1">
                            <div class="card">
                                <img v-if="pageData.image_name" :src="filePath+'/large/'+pageData.image_name" :alt="pageData.heading">
                                <div class="card-body">
                                    <h2 class="card-title">{{ pageData.heading }}</h2>
                                </div>
                            </div>                            
                        </div>
                        <div v-html="pageData.content"></div>                                                
                    </div>
                </div>
            
                <div class="col-12 col-sm-12 col-md-12 col-lg-3" v-if="allServices">
                    <aside class="sidebar services-sidebar" id="sidebar">
                        
                        <div class="widget widget-categories" id="categories">
                            <h4 class="widget-title font-w-semi-b position-relative">Services</h4>
                            <ServiceLists :services="allServices" className="" :module="module" icon="true" />                            
                        </div>
                       
                    </aside>
                </div>            

            </div>
        </div>
    </section>
</fragment>
</template>

<script>
import ServiceLists from './ServiceList'
import InsideHeader from "@/components/InsideHeader.vue";

export default {
    components: {ServiceLists, InsideHeader},
    data(){
        return {    
            breadcrumb: [
                {title: 'Home', path:'/'},
                {title: 'Services', path:'#'}
            ],        
            module: this.$route.meta.slug,
            pageData: [],
            slug: this.$route.params.slug,
            allServices: [],
            filePath: ''
        }
    },
    methods: {
        singleService(){
            this.$http.get(`/services/${this.slug}`).then(res=>{
                
                if(res.status === 200){
                    if(res.data.file_path)
                        this.filePath = res.data.file_path
                    if(res.data.result)
                        this.pageData = res.data.result
                    if(res.data.all_services)
                        this.allServices = res.data.all_services
                }
            }).catch(err=>{
                console.log(err)
            })
        }
    },
    created: function(){
        this.singleService()        
    }
}
</script>

<style scoped>
.services-sidebar .widget h4.widget-title {
    margin: 0 0 20px;
}
</style>